<template>
  <div>
    <div class="vld-parent"></div>
    <b-modal
      id="modalFacebook"
      ref="modal-Facebook"
      class="modalLoginFacebook"
      :hide-header-close="true"
      centered
    >
      <b-container v-if="update">
        <h2>Validar Instagram</h2>
        <p class="textInfo">
          Insira abaixo o perfil do instagram da loja que você deseja validar no
          sistema.
        </p>

        <div></div>
      </b-container>
      <b-container v-else>
        <h2>Novo Instagram</h2>

        <p class="textInfo" v-if="select">
          Selecione a regional em que essa conta pertencerá.
        </p>

        <div v-if="select" class="radios-group-regional">
          <div
            class="form-check radio-regional mb-3 rounded"
            v-for="item in regional"
            :key="item.id"
          >
            <input
              type="radio"
              v-model="choice"
              name="regional-radios"
              :value="item.regionalName"
            />
            <label class="fw-semibold">{{ item.regionalName }}</label>
          </div>
        </div>
        <p v-else class="textInfo">
          Você será direcionado a página de login para sua conta e permitir que
          o sistema faça o gerenciamento de postagens
        </p>
      </b-container>

      <template #modal-footer>
        <b-container>
          <b-row class="">
            <div class="col-lg-6 d-flex justify-content-center">
              <button class="btn btnVoltar" @click="handleButton('back')">
                Voltar
              </button>
            </div>
            <div class="col-lg-6 d-flex justify-content-center">
              <button class="btn btnContinuar" @click="handleButton('next')">
                Continuar
              </button>
            </div>
          </b-row>
        </b-container>
      </template>
    </b-modal>
    <b-modal
      id="modalFacebookAdd"
      ref="modal-FacebookADD"
      :hide-header-close="true"
      centered
    >
      <b-container>
        <h2>Adicionado</h2>
        <p class="textInfo">
          Novo perfil do instagram foi adicionado com sucesso ao sistema.
        </p>
      </b-container>

      <template #modal-footer>
        <b-container>
          <b-row>
            <div class="col-lg-12 d-flex justify-content-center">
              <button class="btn btnVoltarAdd" @click="hideModalFacebookAdd">
                Voltar
              </button>
            </div>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "FacebookLogin",
  props: {
    update: { type: Boolean, default: false },
  },
  data() {
    return {
      select: true,
      regional: [],
      choice: "",
      facebookScopes: "email, manage_fundraisers, user_messenger_contact, threads_business_basic, pages_show_list, read_page_mailboxes, business_management, pages_messaging_phone_number, pages_messaging_subscriptions, instagram_basic, instagram_manage_comments, instagram_manage_insights, instagram_content_publish, pages_read_engagement, pages_manage_metadata, pages_read_user_content, pages_manage_ads, pages_manage_posts, pages_manage_engagement, instagram_branded_content_brand, instagram_branded_content_creator, instagram_branded_content_ads_brand, instagram_manage_events, instagram_manage_upcoming_events, pages_utility_messaging, paid_marketing_messages, instagram_creator_marketplace_discovery, facebook_creator_marketplace_discovery, public_profile, ads_management, ads_read, attribution_read, manage_app_solution, page_events, pages_manage_instant_articles, pages_manage_cta, pages_messaging, catalog_management, whatsapp_business_manage_events, read_insights, publish_video, leads_retrieval, instagram_manage_messages, commerce_account_manage_orders, commerce_account_read_orders, commerce_account_read_reports, commerce_account_read_settings, instagram_shopping_tag_products"
    };
  },
  async created() {
    await this.loadFacebookSDK(document, "script", "facebook-jssdk");
    await this.initFacebook();
    await this.getStoresByRegional().then((response) => {
      this.regional = response.data;
    });

  },
  methods: {
    ...mapActions([
      "carregarPorFacebookUser",
      "gravarInstagramPage",
      "getRolesByPagination",
      "getStoresByRegional",
    ]),

    async getUserFacebook(user) {
      this.$emit("showIsLoading", true);

      await this.carregarPorFacebookUser({
        fbUserId: user.userID,
        fbUserToken: user.accessToken,
      }).then(async (response) => {
        if (response.status == 400) {
          console.error(
            "Nao existe instagram ou paginas cadastrados para esse usuario"
          );
          window.alert(
            "Nao existe instagram ou paginas cadastrados para esse usuario"
          );
        } else {
          response.data.pages[0].instagram.regionalName = this.choice;

          await this.gravarInstagramPage(response.data).then(() => {
            this.getRolesByPagination({
              action: "clickFirstPage",
              offset: 0,
              name: "",
              limit: 3,
            })
              .then(() => {})
              .finally(() => {
                this.$emit("showIsLoading", false);
              });
            this.$refs["modal-FacebookADD"].show();
          });
        }
      });
    },
    async logInWithFacebook() {
      this.$refs["modal-Facebook"].hide();

      const loginOptions = {
        scope: this.facebookScopes,
        return_scopes: true,
      };

      window.FB.login(
        (response) => {

          if (response.authResponse) {
            this.getUserFacebook(response.authResponse);
          } else {
            alert("Usúario não existe ou não autorizado!");
          }
        },
        loginOptions
      );
      return false;
    },
    async initFacebook() {
      window.fbAsyncInit = function () {
        if (process.env.NODE_ENV == "production") {
          window.FB.init({
            cookie: true,
            appId: "883873419293715",
            version: "v15.0",
          });
        } else {
          window.FB.init({
            appId: "855326342519443", //You will need to change this
            cookie: true, // This is important, it's not enabled by default
            version: "v14.0",
          });
        }
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    hideModalFacebook() {
      this.$refs["modal-Facebook"].hide();
    },
    hideModalFacebookAdd() {
      this.$refs["modal-FacebookADD"].hide();
    },
    handleButton(process) {
      if (process === "next") {
        if (this.select) {
          this.select = false;
        } else {
          this.logInWithFacebook();
        }
      } else {
        if (this.select) {
          this.hideModalFacebook();
        } else {
          this.select = true;
        }
      }
    },
  },
};
</script>
<style scoped>
.button {
  color: white;
  min-width: 150px;
  background-color: #000000a1;
  height: 2.5rem;
  border-radius: 2rem;
  font-weight: 400;
  font-size: 0.8rem;
}

.btnVoltar {
  font-size: 1em !important;
  color: #2485ea !important;
  font-weight: 500 !important;
  background: #d3e7fb !important;
  padding: 16px 24px !important;
  transition: 0.5s !important;
  width: 172px !important;
}

.btnVoltar:hover {
  color: #2485ea !important;
  background: #c2ddf8 !important;
}

.btnContinuar {
  font-size: 1em !important;
  color: rgb(255, 255, 255) !important;
  font-weight: 500 !important;
  background: #2485ea !important;
  padding: 16px 24px !important;
  transition: 0.5s !important;
  margin-left: 10px !important;
  width: 172px !important;
}

.btnContinuar:hover {
  color: rgb(255, 255, 255);
  background: #1e7de2;
}

.textInfo {
  color: #8d8c8c !important;
}

.btnVoltarAdd {
  font-size: 1em !important;
  color: #2485ea !important;
  font-weight: 500 !important;
  padding: 16px 24px !important;
  transition: 0.5s !important;
  width: 172px !important;
}

.radios-group-regional {
  max-height: 250px;
  display: block;
  overflow-y: auto;
}

.radio-regional {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #f0f2f8;
}

.radio-regional > input {
  transform: scale(1.4);
}

.radio-regional > label {
  order: -1;
}
</style>
